export default __webpack_public_path__ + "static/media/404.8bd1c92c.svg";